import React, { useEffect, useMemo, useState } from "react"
import Label from "components/general/Label";
import { useViewport } from 'components/general/useViewPort'
import MirsTable from "components/general/table/Table"
import { useUrlFriendlyToParameters } from 'helpers/urlFriendly';
import Noc from "components/presentation/Noc";
import { isParalympic, CompetitionFromStore } from 'helpers/utils'
import Competitor from 'components/presentation/Competitor';
import Discipline from 'components/presentation/Discipline';

const getConfiguration = ({ breakPoint, isAlphabeticalSort = true, params }) => {
  const isMobile = (breakPoint === "sm" || breakPoint === "xs")
  let configuration = {
    columns: [],
    sortBy: [],
    disableSort: false
  };
  configuration.sortBy = [{ id: 'Competitor', desc: false }, { id: 'NOC' }, { id: 'Discipline', desc: false }];
  configuration.columns = isMobile ? TableColumnsSM({ isAlphabeticalSort, params }) : TableColumns({ isAlphabeticalSort, params });
  return configuration;
};


const AthletesTable = ({ data }) => {
  const { breakPoint } = useViewport();
  const params = useUrlFriendlyToParameters();

  const [isAlphabeticalSort, setIsAlphabeticalSort] = useState(true);
  const config = useMemo(() => getConfiguration({ breakPoint, isAlphabeticalSort, params }), [breakPoint, isAlphabeticalSort, params]);

  useEffect(() => {
    let isAlphabetical = !(data?.some(ath => ath?.disciplines?.some(disc => disc?.descriptionOrder !== 0)));
    setIsAlphabeticalSort(isAlphabetical);
  }, [data]);

  return (

    <MirsTable
      className="table-schedule"
      data={data}
      columns={config.columns}
      keyRow='eventUnit-code'
      initialSortBy={config.sortBy}
      id={`mirs-table-athletes`}
      showPagination={true}
    // pageSizeCustom={10}
    />


  )
}

export default AthletesTable;



function TableColumns({ isAlphabeticalSort = true, params }) {
  return (
    [
      ColumnCompetitor({}),
      ColumnNoc({ label: "HeaderTeamNOC", params, longDesc: true }),
      // ColumnDiscipline({})
      ColumnDisciplineNew({ isAlphabeticalSort })
    ]
  )
}

function TableColumnsSM({ isAlphabeticalSort = true, params }) {
  return (
    [
      ColumnCompetitor({}),
      ColumnNoc({ label: "HeaderTeamNOC", params, longDesc: false }),
      ColumnDiscipline({ isAlphabeticalSort })
    ]
  )
}

export function ColumnDiscipline({
  disableSort = false,
  className = 'schedule-discipline text-start',
  headerClassName = 'text-start w-30',
  label = "HeaderDiscipline",
  isAlphabeticalSort = true
}) {
  return (
    {
      Header: <Label data={label} legendFixed={true} />,
      sortType: isAlphabeticalSort ? 'absoluteOrderString' : 'absoluteOrderNumber',
      accessor: (props) => {
        return isAlphabeticalSort ? props?.disciplines?.at(0)?.description?.toLowerCase() : props?.disciplines?.at(0)?.descriptionOrder;
      },
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort, //habilita poder ordenar
      id: 'Discipline',
      Cell: (props) => {
        let disciplines = props.cell.row.original?.disciplines;
        return (disciplines?.map(disc => (
          <Discipline code={disc?.code} description={disc?.description} />
        ))
        )
      }
    }
  )
}

export function ColumnDisciplineNew({
  disableSort = false,
  className = 'schedule-discipline text-start',
  headerClassName = 'text-start w-30',
  label = "HeaderDiscipline",
  isAlphabeticalSort = true
}) {
  return (
    {
      Header: <Label data={label} legendFixed={true} />,
      sortType: isAlphabeticalSort ? 'absoluteOrderString' : 'absoluteOrderNumber',
      accessor: (props) => {
        return isAlphabeticalSort ? props?.disciplines?.at(0)?.description?.toLowerCase() : props?.disciplines?.at(0)?.descriptionOrder;
      },
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort, //habilita poder ordenar
      id: 'Discipline',
      multiSort: [{ id: 'Discipline' }, { id: 'NOC', desc: false }, { id: 'Competitor', desc: false }],
      Cell: (props) => {
        const row = props.cell.row.original;
        const disciplines = row?.disciplines;
        return (
          <div>
            {disciplines?.map((discipline, index) => (
              <div key={index}>
                <Discipline hasLink={true} code={discipline?.code} description={discipline?.description} />
              </div>
            ))}
          </div>
        )
      }
    }
  )
}

export function ColumnNoc({

  disableSort = false,
  className = 'text-start',
  headerClassName = 'text-start w-20',
  label = 'HeaderNOC',
  remove = false,
  longDesc = false,
  params = {}
}) {

  const competition = CompetitionFromStore();
  if (isParalympic(competition) && label === 'HeaderNOC') {
    label = 'HeaderNPC';
  }
  //  const getURL = useGetURL();
  //  const getOCSURL = useGetFunctionOCSUrl()

  return (
    {
      Header: <Label data={label} legendFixed={true} />,
      id: 'NOC',
      accessor: (props) => props?.organisation?.longDescriptionOrder,
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort, //habilita poder ordenar
      multiSort: [{ id: 'NOC' }, { id: 'Competitor', desc: false }, { id: 'Discipline', desc: false }],
      remove: remove,
      Cell: (props) => {
        /*        let paramURL = { ...params }
                paramURL.mirs_noc = props.cell.row.original?.organisation?.code
                let urlSchedule = getURL(paramURL, 'schedulebynoc')
                urlSchedule = getOCSURL(urlSchedule, 'schedulebynoc', paramURL)
                let url = urlSchedule;*/
        let data = props.cell.row.original?.organisation
        return (<Noc {...data} showImage={true} showLongDesc={longDesc} hasLink={true} />);
      }
    }
  )

}

export function ColumnCompetitor({
  disableSort = false,
  className = 'schedule-discipline text-start',
  headerClassName = 'text-start',
  label = "LabelName"
}) {
  return (
    {
      Header: <Label data={label} legendFixed={true} />,
      id: 'Competitor',
      accessor: (props) => (props?.name?.toUpperCase()),
      className: className,
      headerClassName: headerClassName,
      disableSortBy: disableSort, //habilita poder ordenar
      multiSort: [{ id: 'Competitor' }, { id: 'NOC', desc: false }, { id: 'Discipline', desc: false }],
      Cell: (props) => {
        const row = props.cell.row.original
        return (
          <Competitor {...row} hideNoc={true} hidePicture={false} key={`participant-${row?.code}`} />
        )
      }
    }
  )
}

